import logger from '3-foundation/Logging/logger';

import { mapArticlePageProperties } from './PageProperties/articlePagePropertiesMapper';
import { mapNewsPageProperties } from './PageProperties/newsPagePropertiesMapper';
import { mapBasePageProperties } from './PageProperties/basePagePropertiesMapper';
import { mapEventPageProperties } from './PageProperties/eventPagePropertiesMapper';
import { mapContentPageProperties } from './PageProperties/contentPagePropertiesMapper';
import { mapOrganisationPageProperties } from './PageProperties/organisationPagePropertiesMapper';
import { mapContactPersonPageProperties } from './PageProperties/contactPersonPropertiesMapper';
import { mapSearchPageProperties } from './PageProperties/searchPropertiesMapper';
import { mapEventCatalogPageProperties } from './PageProperties/eventCatalogPagePropertiesMapper';
import { mapNewsCatalogPageProperties } from './PageProperties/newsCatalogPagePropertiesMapper';
import { mapDocumentPageProperties } from './PageProperties/documentPagePropertiesMapper';
import { mapDocumentCatalogPageProperties } from './PageProperties/documentCatalogPagePropertiesMapper';
import { mapJobListPageProperties } from './PageProperties/jobListPagePropertiesMapper';

type PageProperties =
	| Content.ArticlePageProperties
	| Content.NewsPageProperties
	| Content.DocumentPageProperties
	| Content.DocumentCatalogPageProperties
	| Content.EventPageProperties
	| Content.ContentPageProperties
	| Content.OrganisationPageProperties
	| Content.ContactPersonPageProperties
	| Content.SearchPageProperties
	| Content.JobListPageProperties
	| Content.BasePage;

const pagePropertiesMappers: Record<
	string,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	(properties: any, pageId: string, siteId: string, locale: string, site?: Site.Site) => PageProperties | Promise<PageProperties>
> = {
	articlePage: mapArticlePageProperties,
	newsPage: mapNewsPageProperties,
	newsCatalogPage: mapNewsCatalogPageProperties,
	documentPage: mapDocumentPageProperties,
	documentCatalogPage: mapDocumentCatalogPageProperties,
	eventPage: mapEventPageProperties,
	eventCatalogPage: mapEventCatalogPageProperties,
	contentPage: mapContentPageProperties,
	organisationPage: mapOrganisationPageProperties,
	contactPersonPage: mapContactPersonPageProperties,
	searchPage: mapSearchPageProperties,
	jobListPage: mapJobListPageProperties,
};

export const mapPageProperties = async ({
	pageId,
	contentType,
	properties,
	siteId,
	site,
	locale,
}: {
	pageId: string;
	contentType: string;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	properties: any;
	siteId: string;
	site: Site.Site;
	locale: string;
}): Promise<PageProperties> => {
	try {
		const mapper = pagePropertiesMappers[contentType];
		if (mapper) {
			return await mapper(properties, pageId, siteId, locale, site);
		} else {
			return await mapBasePageProperties(properties, siteId, locale);
		}
	} catch (e) {
		logger.error(`Could not map PageProperties \nCause: ${e}`);
		throw new Error(`Could not mapPageProperties \nCause: ${e}`, e);
	}
};
